[
  "script",
  "style",
  "pre",
  "textarea"
]
